import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Console banner
console.log('%c' + `
╔══════════════════════════════════════════════════════════╗
║                                                          ║
║     VIRGINIA REGULATORY PLATFORM                        ║
║     Powered by Vulcan Tech                              ║
║                                                          ║
╚══════════════════════════════════════════════════════════╝
`, 'color: #2563eb; font-family: monospace; font-weight: bold');

console.log('%c🚀 Initializing React Application...', 'color: #4CAF50; font-size: 14px; font-weight: bold');
console.log('%c📍 Environment: ' + (import.meta.env.PROD ? 'PRODUCTION' : 'DEVELOPMENT'), 'color: #666');
console.log('%c📅 Build Date: ' + new Date().toISOString(), 'color: #666');
console.log('');

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

console.log('%c✅ React app mounted successfully!', 'color: #4CAF50; font-weight: bold');
